"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateBundleSubtotal = void 0;
var currency_js_1 = __importDefault(require("currency.js"));
/**
 * Expects and returns dollars, not cents.
 * @todo consider using this function in the prebuilt bundler
 */
var calculateBundleSubtotal = function (mainVariant, discountAddons, patterns) {
    var discountAddonsTotalPrice = discountAddons.reduce(function (total, addon) {
        var price = (0, currency_js_1.default)(Number(addon.variant.price));
        return price.multiply(addon.quantity).add(total);
    }, (0, currency_js_1.default)(0));
    var patternsTotalPrice = patterns.reduce(function (total, pattern) {
        var price = (0, currency_js_1.default)(Number(pattern.variant.price));
        return price.multiply(pattern.quantity).add(total);
    }, (0, currency_js_1.default)(0));
    return (0, currency_js_1.default)(mainVariant.price).add(discountAddonsTotalPrice).add(patternsTotalPrice).value;
};
exports.calculateBundleSubtotal = calculateBundleSubtotal;
